@if ({ announcements: announcements$ | async }; as vm) {
	@if (vm.announcements.length) {
		@for (announcement of vm.announcements; track announcement) {
			<div class="announcement">
				<article data-test="article" [innerHTML]="announcement.body | language: false"></article>
				<footer class="muted-footer">
					<span data-test="created-by">
						<i class="fa fa-keyboard-o"></i>
						{{ announcement.createdBy }}
					</span>

					<time>
						<i class="fa fa-clock-o"></i>
						{{ announcement.createdOn | date: "dd/MM/yyyy HH:mm" }}
					</time>
				</footer>
			</div>
		}
	} @else {
		<empty-state
			data-test="empty-state"
			icon="fa fa-bullhorn"
			message="{{ 'home.empty_state_announcements' | translate }}"
		/>
	}
}
